import { uniq } from "lodash";
import { nonEmptyString } from "./nonEmptyString";

export function classNames(...classes: (string | undefined)[]): string {
  return uniq(classes.filter(nonEmptyString)).join(" ");
}
